<template>
  <div class="element-selector">
    <div class="element-grid">
      <div
        v-for="item in dragItems"
        :key="item.id"
        class="element-item"
        :class="{ disabled: isLoading }"
        @click="!isLoading && selectElement(item)"
      >
        <div class="element-icon">
          <cvt-icon :icon="item.icon" />
        </div>
        <div class="element-label">{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { PAGE_ENGINE_VDOM_UPDATE } from '@/js/plugins/events'
import { dragItems, findDragItemById } from './component-details'

export default {
  name: 'ElementSelector',
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
    },
  },
  data() {
    return {
      dragItems: [...dragItems],
      isLoading: false,
    }
  },
  mounted() {
    this.$hub.$on(PAGE_ENGINE_VDOM_UPDATE, this.$hubEventHandler)
  },
  beforeDestroy() {
    this.$hub.$off(PAGE_ENGINE_VDOM_UPDATE, this.$hubEventHandler)
  },
  methods: {
    getElementFromId(id) {
      const dragItem = findDragItemById(id)
      if (dragItem) {
        return dragItem
      }
      return null
    },
    selectElement(item) {
      const element = this.getElementFromId(item.id)
      if (element) {
        this.$emit('element-selected', element)
      }
    },
    $hubEventHandler(event) {
      console.log('$hubEventHandler', event)
      // if (event.type === PAGE_ENGINE_VDOM_UPDATE) {
      //   this.$emit('vdom-updated', event.data)
      // }
    },
  },
}
</script>

<style lang="scss" scoped>
.element-selector {
  padding: 8px;
}

.element-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.element-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #ffffff;
  min-height: 60px;

  &:hover {
    border-color: #007bff;
    background-color: #f8f9fa;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;

    &:hover {
      border-color: #e0e0e0;
      background-color: #ffffff;
      transform: none;
      box-shadow: none;
    }
  }
}

.element-icon {
  font-size: 20px;
  color: #666;
  margin-bottom: 4px;
}

.element-label {
  font-size: 11px;
  color: #333;
  text-align: center;
  font-weight: 500;
  line-height: 1.2;
}

// Dark mode support
:deep(.dark) .element-item {
  background-color: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;

  &:hover {
    border-color: #63b3ed;
    background-color: #4a5568;
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;

    &:hover {
      border-color: #4a5568;
      background-color: #2d3748;
      transform: none;
      box-shadow: none;
    }
  }
}

:deep(.dark) .element-icon {
  color: #a0aec0;
}

:deep(.dark) .element-label {
  color: #e2e8f0;
}
</style>
